module.exports = __webpack_public_path__ + "img/设备背景.cef1e241.png";